import AppModel from '@/models/AppModel'

const isDebug = process.env.NODE_ENV !== 'production'

export default {
  postApi: (bvModal, params = null) => {
    return AppModel.post(
      'order/numbering',
      bvModal,
      params,
      (res) => {
        if (isDebug) {
          console.log(res.data)
        }

        AppModel.validateStatus(res.data)

        return Promise.resolve(res.data)
      },
      (res) => {}
    )
  }
}



// WEBPACK FOOTER //
// ./src/models/OrderNumberingModel.js